window.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type === "submit") {
        const form = document.querySelector(`[data-testid^='klaviyo-form-${e.detail.formId}']`);

        if (!form) return;

        const zipInput = form.querySelector(
            "input[autocomplete='postal-code'], input[placeholder*='Zip']"
        );
        let region = "unknown";

        if (zipInput) {
            console.log('zipInput', zipInput);
            const zipCode = zipInput.value.trim();
           console.log('zipCode', zipCode);
            const state = getStateFromZip(zipCode);
            console.log('state', state);
            if (state) region = state;
        }

        const _learnq = window._learnq || [];

        _learnq.push([
            "identify",
            {
                region: region,
            },
        ]);
    }
});
